import * as yup from 'yup'
import * as inRange from 'lodash/inRange'
import { TYPE_REQUIRED } from 'constants/errors'
import { SignedCurrencyFieldState } from 'interfaces/component'

const MANUAL_ACCOUNT_BALANCE_MIN = -999999999
const MANUAL_ACCOUNT_BALANCE_MAX = 999999999
const MANUAL_ACCOUNT_NAME_MESSAGE = `Please only use letters, numbers, and spaces`

export const MANUAL_ACCOUNT_NAME_MAX_LENGTH = 32

const manualAccountNameRegex = new RegExp(`^[A-z0-9!@#$%^&*_\\-+ '",\.]{0,${ MANUAL_ACCOUNT_NAME_MAX_LENGTH }}$`)

export default yup.object().shape({
  name: yup.string()
    .required(TYPE_REQUIRED)
    .matches(
      manualAccountNameRegex,
      MANUAL_ACCOUNT_NAME_MESSAGE,
    )
    .test('not-only-spaces', TYPE_REQUIRED, (name: string) => {
      return name.trim().length !== 0
    }),
  amount: yup.mixed()
    .test('signed-amount', TYPE_REQUIRED, (amount: SignedCurrencyFieldState): boolean => {
      return amount.absValue !== null
    })
    .test('manual-account-balance-range', `Balance can't exceed $1B`, (amount: SignedCurrencyFieldState): boolean => {
      if (amount.absValue === null) {
        // delegate the case to 'signed-amount'
        return true
      }

      // MANUAL_ACCOUNT_BALANCE_MAX + 1 because _.inRange compares strictly upper bound
      return inRange(amount.absValue, MANUAL_ACCOUNT_BALANCE_MIN, MANUAL_ACCOUNT_BALANCE_MAX + 1)
    }),
  category: yup.mixed().required(TYPE_REQUIRED),
})
